import {BrowserRouter} from "react-router-dom";
import {AuthContextProvider} from "Context/authContext";
import {BusinessContextProvider} from "Context/businessContext";
import {SocketContextProvider} from "Context/socketContext";
import GlobalStyles, {StyledToastContainer} from "styles/GlobalStyles.styles";
import Router from "Router";
import {ThemeProvider} from "Context/themeContext";
import {LocationContextProvider} from "Context/location";
import "react-toastify/dist/ReactToastify.min.css";

const App = () => {
    return (
        <AuthContextProvider>
            <BusinessContextProvider>
                <SocketContextProvider>
                    <LocationContextProvider>
                        <BrowserRouter>
                            <ThemeProvider>
                                <GlobalStyles />
                                <Router />
                            </ThemeProvider>
                        </BrowserRouter>
                        <StyledToastContainer />
                    </LocationContextProvider>
                </SocketContextProvider>
            </BusinessContextProvider>
        </AuthContextProvider>
    );
};

export default App;
